import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    thirdParty: '', // 1-第三方页面  0-同源页面
  },
  getters: {
    thirdParty: state => state.thirdParty
  },
});


// WEBPACK FOOTER //
// ./src/store.js